import React, { createContext, ReactElement, ReactNode, useContext } from 'react';
import { ModalManager } from './ModalManager';

export interface ModalManagerProviderProps {
  value: ModalManager;
  children?: ReactNode;
}

export const ModalManagerContext = createContext<ModalManager>({} as ModalManager);

export function useModalManager(): ModalManager {
  const context = useContext(ModalManagerContext);

  if (context === undefined) {
    throw new Error('useModalManager was used outside of its Provider');
  }

  return context;
}

export function ModalManagerProvider({ value, children }: ModalManagerProviderProps): ReactElement {
  return <ModalManagerContext.Provider value={value}>{children}</ModalManagerContext.Provider>;
}
